import { useTranslate } from 'hooks';

const DemoLabel = () => {
  const { t } = useTranslate();

  return (
    <dl className="inline-block">
      <dt className="text-[10px] md:text-base leading-6 font-semibold px-4 py-[2px] md:py-2 w-auto rounded-xsmall md:rounded-small bg-black md:bg-white text-white md:text-black inline-block mb-[6px] md:mb-3">
        {t('lang.demo')}
      </dt>
      <dd className="font-semibold leading-3 text-[10px] md:text-base">{t('lang.demo_payment')}</dd>
    </dl>
  );
};

export { DemoLabel };
